import './FAQ.css';
import { NavLink } from 'react-router-dom';

const faqItems = [
  { title: 'Was ist GTA V RP / Roleplay?', to: '/faq/was-ist-gta-v-rp-roleplay', icon: '🎭' },
  { title: 'Wie ist GTA V RP / Roleplay entstanden?', to: '/faq/wie-ist-gta-v-rp-entstanden', icon: '📜' },
  { title: 'Was benötigt man um Roleplay spielen zu können?', to: '/faq/was-benoetigt-man', icon: '🎮' },
  { title: 'Ich habe ein PC, wie kann ich Roleplay spielen?', to: '/faq/wie-kann-ich-rp-spielen', icon: '💻' },
  { title: 'Was sollte ich beachten um Roleplay zu spielen?', to: '/faq/was-sollte-ich-beachten', icon: '⚠️' },
  { title: 'Alle GTA Roleplay Begriffe auf einen Blick', to: '/faq/glossar', icon: '📚' },
  { title: 'Wie kann man GTA RP spielen?', to: '/faq/wie-kann-man-gta-rp-spielen', icon: '🚀' },
  { title: 'Was braucht man für GTA RP?', to: '/faq/was-braucht-man-fuer-gta-rp', icon: '🛠️' },
  { title: 'GTA RP Server deutsch Liste', to: '/faq/deutsche-rp-server', icon: '🇩🇪' },
  { title: 'Was ist RDM und VDM in RP?', to: '/faq/rdm-und-vdm', icon: '🚫' },
  { title: 'Kann man GTA RP auf PS5 oder PS4 spielen?', to: '/faq/gta-rp-auf-konsolen', icon: '🎮' },
  { title: 'Was braucht man um GTA 5 Online zu spielen?', to: '/faq/gta-online-voraussetzungen', icon: '🌐' }
];

export default function FAQ() {
  return (
    <div className="page faq-page">
      <h1>FAQ - Häufig gestellte Fragen</h1>
      <p className="faq-subtitle">Alle nötigen Informationen zu GTA Roleplay</p>

      <div className="faq-intro">
        <p>
          RP Streams beantwortet die häufigsten Fragen zu GTA V Roleplay auf Deutsch: Was Roleplay ist,
          welche Voraussetzungen du brauchst, wie FiveM funktioniert und welche Regeln (RDM, VDM, OOC)
          fast alle Server voraussetzen.
        </p>
        <p>
          Nutze die Artikel unten als Einstieg. Für Live-Streams geht es zurück zur <a href="/">Startseite</a>,
          für Serververgleiche zum <a href="/top-streamers">Servervoting</a>.
        </p>
      </div>

      <div className="faq-list">
        {faqItems.map((item) => (
          <NavLink key={item.to} to={item.to} className="faq-item">
            <span className="faq-item-icon">{item.icon}</span>
            <span className="faq-item-title">{item.title}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
}
